if (!customElements.get('td-design-features')) {
  class TdDesignFeatures extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('.td-pdp-design-features__carousel');
      if (!this.carousel) return;
      this.initWhenReady();
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
      if (this.readyTimer) clearTimeout(this.readyTimer);
    }

    initWhenReady(attempts) {
      if (typeof window.Swiper !== 'function') {
        const tries = attempts || 0;
        if (tries < 100) this.readyTimer = setTimeout(() => this.initWhenReady(tries + 1), 50);
        return;
      }
      const prevEl = this.querySelector('[data-td-df-prev]');
      const nextEl = this.querySelector('[data-td-df-next]');
      const scrollbarEl = this.querySelector('.td-pdp-design-features__progress');
      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        grabCursor: true,
        watchOverflow: true,
        longSwipesRatio: 0.15,
        breakpoints: {
          1000: {
            spaceBetween: 38.5,
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60
          }
        }
      };
      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl, disabledClass: 'td-pdp-design-features__arrow--disabled' };
      }
      if (scrollbarEl) {
        config.scrollbar = { el: scrollbarEl, draggable: true };
      }
      this.swiper = new window.Swiper(this.carousel, config);
    }
  }

  customElements.define('td-design-features', TdDesignFeatures);
}
